import React from 'react';
import { ArrowLeftOutlined, CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Logo from '../../../../components/Logo';
import {
  ChildrenWrapper,
  Container,
  Content,
  FooterDivContainer,
  Header,
  LogoContainer,
  NavigationContainer,
  OverlayContainer,
  TitleWrapper,
  TitleFmlStyle
} from './PageContainer.styles';
import { pageConfigs } from '../../configs/pageConfigs';
import { ButtonLarge, FooterDiv } from '../../../../components/Css';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { isBannerEnabled, getBannerImageUrl, getBannerStyles } from 'utils/getBannerConfig';
import { getTitleStyles } from 'utils/getTitleConfig';
import { useGAEvents } from '../../../../hooks/useGoogleAnalytics';

interface FullScreenOverlayProps {
  children: React.ReactNode;
  title?: string;
  navigateClose?: boolean;
  navigateBack?: string;
  onClick?: () => void
  thereIsButton?: boolean;
  buttonText?: string
  loading?: boolean
  disabled?: boolean
  extraAboveButton?: React.ReactNode
  extraBelowButton?: React.ReactNode
}

const PageContainer: React.FC<FullScreenOverlayProps> = ({
                                                           children,
                                                           title,
                                                           navigateClose = true,
                                                           navigateBack,
                                                           buttonText,
                                                           onClick,
                                                           thereIsButton = false,
                                                           disabled,
                                                           loading,
                                                           extraAboveButton,
                                                           extraBelowButton
                                                         }) => {
  const navigate = useNavigate();
  const { events } = useGAEvents();
  
  const handleClose = () => {
    // Evento GA4: Clique no botão fechar
    events.buttonClick('close_page', title || 'unknown_page');
    navigate(pageConfigs.welcome.navigateToWelcome())
  };
  
  const handleBack = () => {
    // Evento GA4: Clique no botão voltar
    events.buttonClick('back_navigation', title || 'unknown_page');
    if (navigateBack) navigate(navigateBack);
  };
  
  const handleMainButtonClick = () => {
    // Evento GA4: Clique no botão principal da página
    events.buttonClick('main_action', `${title || 'unknown_page'}_${buttonText || 'unknown_action'}`);
    if (onClick) onClick();
  };

  return (
    <>
      <TitleFmlStyle />
      <OverlayContainer> 
          <Header>
            <LogoContainer onClick={handleClose}>
              <Logo />
            </LogoContainer>
          </Header>      
        <Content>
          <Container>
            <NavigationContainer>
              {navigateBack && <ArrowLeftOutlined onClick={handleBack}/>}
              
              {navigateClose && <CloseOutlined onClick={handleClose}/>}
            </NavigationContainer>
            
            <TitleWrapper><span className="title-fml">{title}</span></TitleWrapper>
            
            <ChildrenWrapper>
              {children}
            </ChildrenWrapper>
            {extraAboveButton}
          </Container>
          
          {
            thereIsButton &&
            <FooterDivContainer>
              <FooterDiv>
                <ButtonLarge
                  onClick={handleMainButtonClick}
                  loading={loading}
                  disabled={disabled}>
                  {buttonText}
                </ButtonLarge>
              </FooterDiv>
            </FooterDivContainer>
          }
          {extraBelowButton}
        </Content>
      </OverlayContainer>
    </>
  );
};

export default PageContainer;
